import { firebaseApp } from "../firebase";
import { getDatabase, ref, get, set, update, child } from "firebase/database";
import { saveAs } from "file-saver";

const state = {
  backup: "",
  lastBackup: "",
};

const getters = {
  backup(state) {
    return state.backup;
  },
  lastBackup(state) {
    return state.lastBackup;
  },
};

const actions = {
  resetBackup({ commit }) {
    commit("saveBackup", "");
  },
  loadLastBackup({ commit }) {
    const db = getDatabase(firebaseApp);
    const dbRef = ref(db);
    get(child(dbRef, "admin/backup"))
      .then((snapshot) => {
        if (snapshot.exists()) {
          const txt = snapshot.val();
          commit("loadLastBackup", txt);
        } else {
          console.log("No data available");
          commit("loadLastBackup", "");
        }
      })
      .catch((error) => {
        console.error(error);
        commit("loadAutorizados", []);
      });
  },
  setLastBackup({ dispatch }, txt) {
    const db = getDatabase(firebaseApp);
    const updates = {};
    updates["admin/backup/"] = txt;
    update(ref(db), updates);
    dispatch("loadLastBackup");
  },
  saveBackup({ commit }) {
    const db = getDatabase(firebaseApp);
    const dbRef = ref(db);
    let date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    const arquivo = `backup ${year}-${month}-${day} ${hours}_${minutes}_${seconds}.json`;

    get(dbRef)
      .then((snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.val();
          const blob = new Blob([JSON.stringify(data)], {
            type: "application/json",
          });
          saveAs(blob, arquivo);
          commit("saveBackup", arquivo);
        } else {
          commit("saveBackup", "Dados não encontrados.");
        }
      })
      .catch((error) => {
        commit("saveBackup", error);
      });
  },
  revertBackup({ commit }) {
    const db = getDatabase(firebaseApp);
    const dbRef = ref(db);
    fetch("path/to/backup.json")
      .then((response) => response.json())
      .then((data) => {
        set(dbRef, data);
        commit("saveBackup", "Dados restaurados com sucesso.");
      })
      .catch((error) => {
        commit("saveBackup", error);
      });
  },
};

const mutations = {
  saveBackup(state, obj) {
    state.backup = obj;
  },
  loadLastBackup(state, txt) {
    state.lastBackup = txt;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
